import React from "react";
import IconTooltipButton from "../../../../button/IconTooltipButton";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

export const AddWorkedExampleGranularStepButton = ({ type, onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );

  return (
    <>
      {id &&
        ["updated"].includes(type) &&
        (permissions?.updated.includes("created-granular-step") ||
          permissions?.updated.includes("updated-granular-step") ||
          permissions?.updated.includes("deleted-granular-step")) && (
          <IconTooltipButton
            title="Add worked example"
            icon={["fal", "chalkboard-user"]}
            onClick={onClick}
            color="primary"
            classNameIcon="text-xs "
            style={{
              width: 24,
              height: 24,
              backgroundColor: "#fff",
            }}
          />
        )}
    </>
  );
};

export const UpdateWorkedExampleGranularStepButton = ({ type, onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );

  return (
    <>
      {id &&
        ["updated"].includes(type) &&
        (permissions?.updated.includes("created-granular-step") ||
          permissions?.updated.includes("updated-granular-step") ||
          permissions?.updated.includes("deleted-granular-step")) && (
          <IconTooltipButton
            title="Update worked example"
            icon={["fas", "edit"]}
            onClick={(we) => onClick(we)}
            style={{
              width: 24,
              height: 24,
              color: "var(--primary)",
            }}
          />
        )}
    </>
  );
};

export const DeleteWorkedExampleGranularStepButton = ({ type, onClick }) => {
  const { id } = useParams();
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );

  return (
    <>
      {id &&
        ["updated"].includes(type) &&
        (permissions?.updated.includes("created-granular-step") ||
          permissions?.updated.includes("updated-granular-step") ||
          permissions?.updated.includes("deleted-granular-step")) && (
          <IconTooltipButton
            title="Delete worked example"
            icon="trash-alt"
            onClick={(we) => onClick(we)}
            style={{
              width: 24,
              height: 24,
              color: "var(--muted-foreground)",
            }}
          />
        )}
    </>
  );
};

export const AddGranularStepButton = ({ type, onClick, level }) => {
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );

  return (
    <>
      {((["create"].includes(type) && permissions?.created) ||
        (["created-granular-step", "updated"].includes(type) &&
          permissions?.updated.includes("created-granular-step"))) && (
        <IconTooltipButton
          title="Add granular steps"
          icon="plus"
          onClick={onClick}
          style={{
            width: 24,
            height: 24,
            backgroundColor: level?.secondaryColor,
            color: level?.primaryColor,
          }}
        />
      )}
    </>
  );
};

export const UpdateGranularStepButton = ({ type, onClick }) => {
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );
  return (
    <>
      {((["create"].includes(type) && permissions?.created) ||
        (["updated-granular-step", "updated"].includes(type) &&
          permissions?.updated.includes("updated-granular-step"))) && (
        <IconTooltipButton
          title="Update granular steps"
          icon={["fas", "edit"]}
          onClick={onClick}
          style={{
            width: 24,
            height: 24,
            color: "var(--primary)",
          }}
        />
      )}
    </>
  );
};

export const DeleteGranularStepButton = ({ type, onClick }) => {
  const permissions = useSelector(
    (state) => state?.session?.permissions?.dr || {}
  );
  return (
    <>
      {((["create"].includes(type) && permissions?.created) ||
        (["deleted-granular-step", "updated"].includes(type) &&
          permissions?.updated.includes("deleted-granular-step"))) && (
        <IconTooltipButton
          title="Delete granular steps"
          icon="trash-alt"
          onClick={onClick}
          style={{
            width: 24,
            height: 24,
            color: "var(--muted-foreground)",
          }}
        />
      )}
    </>
  );
};
